import React from "react";
import { useAuth } from "../../../components/authContext"; // update path if needed
import StyledButton from "../../components/button";
import StyledInput from "../../components/input";
import ExerciseDropdown from "../components/exerciseblock";

interface Set {
  reps: string;
  weight: string;
  rpe: string;
}

interface Superset {
  exercise: string;
  sets: Set[];
}

interface Props {
  supersets: Superset[];
  setSupersets: (s: Superset[]) => void;
  onSave: () => void;
}

const LiftTrackerForm: React.FC<Props> = ({
  supersets,
  setSupersets,
  onSave,
}) => {
  const { user } = useAuth();

  if (!user) return <p>Loading user...</p>; // prevent crashes if user is undefined

  const handleSetChange = (
    supersetIndex: number,
    setIndex: number,
    field: keyof Set,
    value: string
  ) => {
    const updated = [...supersets];
    updated[supersetIndex].sets[setIndex][field] = value;
    setSupersets(updated);
  };

  const handleExerciseChange = (index: number, value: string) => {
    const updated = [...supersets];
    updated[index].exercise = value;
    setSupersets(updated);
  };

  const handleAddSet = (index: number) => {
    const updated = [...supersets];
    updated[index].sets.push({ reps: "", weight: "", rpe: "" });
    setSupersets(updated);
  };

  const handleRemoveSet = (index: number) => {
    const updated = [...supersets];
    if (updated[index].sets.length > 1) updated[index].sets.pop();
    setSupersets(updated);
  };

  const handleAddSuperset = () => {
    setSupersets([
      ...supersets,
      { exercise: "", sets: [{ reps: "", weight: "", rpe: "" }] },
    ]);
  };

  const handleRemoveSuperset = () => {
    if (supersets.length > 1) setSupersets(supersets.slice(0, -1));
  };

  return (
    <>
      {supersets.map((superset, i) => (
        <div key={i} style={{ marginBottom: "16px" }}>
          <h3>Superset {i + 1}</h3>

          <ExerciseDropdown
            value={superset.exercise}
            onChange={(e) => handleExerciseChange(i, e)}
            uid={user.uid} // ✅ fixed here
            mode="lift"
          />

          {superset.sets.map((set, j) => (
            <div key={j}>
              <p>Set {j + 1}</p>
              <div style={{ display: "flex", gap: "8px" }}>
                <StyledInput
                  placeholder="Reps"
                  value={set.reps}
                  onChange={(e) =>
                    handleSetChange(i, j, "reps", e.target.value)
                  }
                />
                <StyledInput
                  placeholder="Weight"
                  value={set.weight}
                  onChange={(e) =>
                    handleSetChange(i, j, "weight", e.target.value)
                  }
                />
                <StyledInput
                  placeholder="RPE"
                  value={set.rpe}
                  onChange={(e) => handleSetChange(i, j, "rpe", e.target.value)}
                />
              </div>
            </div>
          ))}

          <div style={{ marginTop: "12px", display: "flex", gap: "12px" }}>
            <StyledButton onClick={() => handleAddSet(i)}>
              + Add Set
            </StyledButton>
            <StyledButton onClick={() => handleRemoveSet(i)}>
              − Remove Set
            </StyledButton>
          </div>
        </div>
      ))}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "16px",
        }}
      >
        <StyledButton onClick={onSave}>Log Workout</StyledButton>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "12px", marginBottom: "4px" }}>
            Add Superset
          </span>
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <button
              onClick={handleRemoveSuperset}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                fontSize: "24px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                border: "none",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              −
            </button>
            <span style={{ fontSize: "18px" }}>{supersets.length}</span>
            <button
              onClick={handleAddSuperset}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                fontSize: "24px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                border: "none",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              +
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LiftTrackerForm;
